const POPUP_COOKIE = 'js360_lead_popup_v1';
const SUBSCRIBED_COOKIE = 'js360_lead_subscribed';

function isBrowser() {
  return typeof document !== 'undefined';
}

function setCookie(name, value, days = null) {
  if (!isBrowser()) return;

  const encodedValue = encodeURIComponent(value);
  const expires = typeof days === 'number'
    ? `; expires=${new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()}`
    : '';
  const secure = typeof window !== 'undefined' && window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${name}=${encodedValue}${expires}; path=/; SameSite=Lax${secure}`;
}

function getCookie(name) {
  if (!isBrowser()) return null;

  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
  if (!match) return null;

  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}

export function setLeadPopupClosedCookie() {
  setCookie(POPUP_COOKIE, 'closed', 7);
}

export function setLeadPopupDontShowCookie() {
  setCookie(POPUP_COOKIE, 'dont_show', 90);
}

export function setLeadSubscribedCookie() {
  // Keep one canonical suppression cookie name as required by product spec.
  // "Permanent" suppression is represented as far-future persistence (10 years).
  setCookie(POPUP_COOKIE, 'subscribed', 3650);
}

export function getLeadPopupSuppressionCookie() {
  return getCookie(POPUP_COOKIE);
}

export function isLeadSubscribedCookieSet() {
  // Backward compatibility for older clients that may still have a legacy cookie.
  return getCookie(POPUP_COOKIE) === 'subscribed' || getCookie(SUBSCRIBED_COOKIE) === 'true';
}
